import { DataFarmType } from '../dataFarmType';
import { DataTransform } from '../dataTransform';
import { SortInfo } from '../sortInfo';
import { TransformRule } from '../transformRule';
import { TransformType } from '../transformType';
import { group } from '@angular/animations';

export class GroupAttributorTransform extends DataTransform<GroupAttributorTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.groupAttributor,nodeID);
      this.transformConfig = new GroupAttributorTransformConfig();
    }

    static fromJSON(data: any): GroupAttributorTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: GroupAttributorTransform = Object.assign(new GroupAttributorTransform(0, 0, '', ''), data);
        if (instance.transformConfig) {
            instance.transformConfig = GroupAttributorTransformConfig.fromJSON(instance.transformConfig);
        }

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class GroupAttributorTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: DataFarmType;
    transformType: TransformType;
    defSourceField: string;
    defTargetField: string;
    groupBy: string;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    userField: string;
    timestampField: string;
    sampleStart: number;
    sampleEnd: number;
    listSeparator: string;
    separateBy: string;
    defTimeout: number;
    runAll:boolean;
    bufferRows: number
    threads: number;
    addFields: any[];
    defInclude: number;
    updateGroupsAtEnd:boolean;
    fillOption: FillOptionType;
    resetRows:boolean;
    
    rules: GroupAttributorTransformRule[];

    static fromJSON(data: any): GroupAttributorTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: GroupAttributorTransformConfig = Object.assign(new GroupAttributorTransformConfig(), data);

        const rules: GroupAttributorTransformRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = GroupAttributorTransformRule.fromJSON(r);
                rules.push(rule);
            });
        }

        instance.rules = rules;
        return instance;
    }
}

export class GroupAttributorTransformRule extends TransformRule {
    groupFill: GroupFillType;
    groupByValue?: string;
    fieldStart: string;
    whenStart: WhenType;
    conditionStart: ConditionType;
    stringStart: string;
    groupByStart: GroupByType;
    fieldEnd: string;
    whenEnd: WhenType;
    conditionEnd?: ConditionType;
    stringEnd: string;
    groupByEnd: GroupByType;
    timeout = 5 * 60;
    include = 1;

    static fromJSON(data: any): GroupAttributorTransformRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: GroupAttributorTransformRule = Object.assign(new GroupAttributorTransformRule(), data);

        return instance;
    }
}

export enum FillOptionType {
    skipGroupStrings = 0,
    includeGroupStrings = 1
}

export class FillOptionTypeUtil {
    static toString(val: FillOptionType): string {
        switch (val) {
            case FillOptionType.skipGroupStrings:
                return 'Skip Group Strings';
            case FillOptionType.includeGroupStrings:
                return 'Include Group Strings';
        }
    }
}

export enum GroupByType {
    ignore = 0,
    changes = 1
}

export class GroupByTypeUtil {
    static toString(val: GroupByType): string {
        switch (val) {
            case GroupByType.ignore:
                return 'Ignore';
            case GroupByType.changes:
                return 'Changes';
        }
    }
}

export enum GroupFillType {
    beforeStartRow = 0,
    atStartRow = 1,
    afterStartRow = 2,
    atEndRow = 3,
    afterEndRow = 4,
    value = 5
}

export class GroupFillTypeUtil {
    static toString(val: GroupFillType): string {
        switch (val) {
            case GroupFillType.beforeStartRow:
                return 'Before Start Row';
            case GroupFillType.atStartRow:
                return 'At Start Row';
            case GroupFillType.afterStartRow:
                return 'After Start Row';
            case GroupFillType.atEndRow:
                return 'At End Row';
            case GroupFillType.afterEndRow:
                return 'After End Row';
            case GroupFillType.value:
                return 'Value';
        }
    }
}

export enum WhenType {
    changesTo = 0,
    changesFrom = 1,
    notInGroup = 2
}

export class WhenTypeUtil {
    static toString(val: WhenType): string {
        switch (val) {
            case WhenType.changesTo:
                return 'Changes to';
            case WhenType.changesFrom:
                return 'Changes from';
            case WhenType.notInGroup:
                return 'Not in group';
        }
    }
}

export enum ConditionType {
    equals = 0,
    contains = 1,
    startsWith = 2,
    endsWith = 3,
    notEquals = 4,
    notContains = 5,
    notStartsWith = 6,
    notEndsWith = 7
}

export class ConditionTypeUtil {
    static toString(val: ConditionType): string {
        switch (val) {
            case ConditionType.equals:
                return 'Equals';
            case ConditionType.contains:
                return 'Contains';
            case ConditionType.startsWith:
                return 'Starts with';
            case ConditionType.endsWith:
                return 'Ends with';
            case ConditionType.notEquals:
                return 'Not equals';
            case ConditionType.notContains:
                return 'Not contains';
            case ConditionType.notStartsWith:
                return 'Not starts with';
            case ConditionType.notEndsWith:
                return 'Not ends with';
        }
    }
}